import React from 'react';
import Icon from '../../../components/AppIcon';
import { cn } from '../../../utils/cn';

const ReportCategoryTabs = ({ activeCategory, onCategoryChange }) => {
  const categories = [
    {
      id: 'financial',
      label: 'Financial Reports',
      icon: 'DollarSign',
      description: 'Revenue, settlements, reconciliation'
    },
    {
      id: 'fraud',
      label: 'Fraud Analytics',
      icon: 'Shield',
      description: 'Risk patterns, anomaly detection'
    },
    {
      id: 'merchant',
      label: 'Merchant Intelligence',
      icon: 'Store',
      description: 'Performance, onboarding, activity'
    },
    {
      id: 'compliance',
      label: 'Compliance Documentation',
      icon: 'FileCheck',
      description: 'Regulatory reports, audit trails'
    }
  ];

  return (
    <div className="card">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {categories?.map((category) => (
          <button
            key={category?.id}
            onClick={() => onCategoryChange(category?.id)}
            className={cn(
              'flex flex-col items-start gap-2 p-4 rounded-lg border-2 transition-all duration-200',
              activeCategory === category?.id
                ? 'border-primary bg-primary/10' :'border-border hover:border-primary/50 hover:bg-accent'
            )}
          >
            <div className="flex items-center gap-3 w-full">
              <div
                className={cn(
                  'p-2 rounded-lg',
                  activeCategory === category?.id
                    ? 'bg-primary/20' :'bg-muted'
                )}
              >
                <Icon
                  name={category?.icon}
                  size={20}
                  className={cn(
                    activeCategory === category?.id
                      ? 'text-primary' :'text-muted-foreground'
                  )}
                />
              </div>
              <div className="flex-1 text-left">
                <h4
                  className={cn(
                    'text-sm font-semibold',
                    activeCategory === category?.id
                      ? 'text-primary' :'text-foreground'
                  )}
                >
                  {category?.label}
                </h4>
                <p className="text-xs text-muted-foreground mt-0.5">
                  {category?.description}
                </p>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ReportCategoryTabs;